import React from "react";
import { Site } from "../../interfaces/site";
import { Bâtiment, Espace, Niveau, Piece } from "../../interfaces/geospatiale";
import {
  getTotalBatiments,
  getTotalNiveaux,
  getTotalEspaces,
  getTotalPieces,
  renderIndicator,
} from "./IndicatorsOperation";

interface DynamicIndicatorProps {
  selectedSites?: Site[];
  loading: boolean;
  sites: Site[];
  batiments: Bâtiment[];
  niveaux: Niveau[];
  espaces: Espace[];
  pieces: Piece[];
}

const DynamicIndicator = ({
  selectedSites,
  loading,
  sites,
  batiments,
  niveaux,
  espaces,
  pieces,
}: DynamicIndicatorProps) => {
  return (
    <div className="flex space-x-5">
      {selectedSites?.length > 0 ? (
        <>
          {renderIndicator(
            "Bâtiment(s)",
            loading,
            getTotalBatiments(selectedSites),
            <img src="/images/batiments-3d.png" className="mx-2" />
          )}
          {renderIndicator(
            "Niveau(x)",
            loading,
            getTotalNiveaux(selectedSites),
            <img src="/images/couches.png" className="mx-2" />
          )}
          {renderIndicator(
            "Espace(s)",
            loading,
            getTotalEspaces(selectedSites),
            <img src="/images/espace.png" className="mx-2" />
          )}
          {renderIndicator(
            "Pièce(s)",
            loading,
            getTotalPieces(selectedSites),
            <img src="/images/piece.png" className="mx-2" />
          )}
        </>
      ) : (
        <>
          {renderIndicator(
            "Site (s)",
            loading,
            sites?.length,
            <img src="/images/composants.png" className="mx-2" />
          )}
          {renderIndicator(
            "Bâtiment (s)",
            loading,
            batiments?.length,
            <img src="/images/batiments-3d.png" className="mx-2" />
          )}
          {renderIndicator(
            "Niveau (x)",
            loading,
            niveaux?.length,
            <img src="/images/couches.png" className="mx-2" />
          )}
          {renderIndicator(
            "Espace (s)",
            loading,
            espaces?.length,
            <img src="/images/espace.png" className="mx-2" />
          )}
          {renderIndicator(
            "Pièce (s)",
            loading,
            pieces?.length,
            <img src="/images/piece.png" className="mx-2" />
          )}
        </>
      )}
    </div>
  );
};

export default DynamicIndicator;
